<template>
  <div class="app-container">
    <transition name="el-zoom-in-top">
      <div v-show="!showadd" class="filter-container">
        <el-button class="filter-item" type="info" icon="el-icon-back" @click="back">{{ $t('table.back') }}</el-button>
        <el-date-picker v-model="startTime" type="datetime" placeholder="选择开始时间" />
        <el-date-picker v-model="endTime" type="datetime" placeholder="选择结束时间" />
        <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="search()">{{ $t('table.search') }}</el-button>
      </div>
    </transition>
    <transition name="el-zoom-in-top">
      <div v-show="!showadd" class="filter-container">
        <el-table
          v-loading="listLoading"
          :key="tableKey"
          :data="list"

          fit
          stripe
          highlight-current-row
          style="width: 100%;">
          <el-table-column :label="$t('table.orderNo')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.OrderNo">{{ scope.row.OrderInfo.OrderNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.OrderState')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.OrderState">{{ scope.row.OrderInfo.OrderState === 'A' ? '进行中' : scope.row.OrderInfo.OrderState === 'D' ? '使用中' : scope.row.OrderInfo.OrderState === 'S' ? '订单结束 ' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.userName')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.UserName">{{ scope.row.UserName }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.telPhone')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.TelPhone">{{ scope.row.TelPhone }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.BoxNo')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.BoxNo">{{ scope.row.OrderInfo.BoxNo }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.boxTypeNo')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.BoxInfo.TypeNo">{{ scope.row.BoxInfo.TypeNo === 'Big' ? '大' : scope.row.BoxInfo.TypeNo === 'Mid' ? '中' : scope.row.BoxInfo.TypeNo === 'Small' ? '小' : scope.row.BoxInfo.TypeNo === 'SuperBig' ? '超级大' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.expense')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.OrderInfo.PayMoney }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.payway')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.PayType">{{ scope.row.OrderInfo.PayType === 'Wx' ? '微信支付' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.startTime ')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.StartTime">{{ scope.row.OrderInfo.StartTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('table.endTime')" prop="Identity" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.OrderInfo.EndTime">{{ scope.row.OrderInfo.EndTime }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>

        </el-table>
        <div class="pagination-container">
          <el-pagination v-show="total>0" :current-page="listQuery.pageIndex" :page-sizes="[10,20,50,100]" :page-size="listQuery.pageSize" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange"/>
        </div>
        <div v-show="false">{{ ids }}</div>
      </div>
    </transition>
  </div>
</template>
<script>
import { qryDeviceUseDetails } from '@/api/device'
import waves from '@/directive/waves' // 水波纹指令
export default {
  name: 'OrderManage',
  directives: {
    waves
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      listLoading: true,
      permition: null,
      showadd: false,
      startTime: null,
      endTime: null,
      listQuery: {
        pageIndex: 1,
        pageSize: 10
      },
      list: null,
      tableKey: 0,
      bookType: 'xlsx',
      bookTypeList: ['xlsx', 'csv', 'txt'],
      total: null
    }
  },
  computed: {
    ids() {
      if (this.id) {
        this.qryList()
      }
      return this.id
    }
  },
  created() {
  },
  methods: {
    // 获取设备使用记录
    qryList: function() {
      this.listQuery.dId = this.id
      qryDeviceUseDetails(this.listQuery).then(request => {
        this.list = request.LsList.LsList
        this.total = request.LsList.TotalRows
        this.listLoading = false
        console.log(this.list)
      })
    },
    // 搜索
    search() {
      this.listQuery.startTime = this.startTime
      this.listQuery.endTime = this.endTime
      this.qryList()
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.qryList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.qryList()
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>
<style scoped>
</style>
